import React from 'react';
import { Sun, ArrowRight } from 'lucide-react';

// Glowing frosted-glass entry pill for the Seasonal Planting Template.
export function EntryPill({ onClick }) {
  return (
    <button
      onClick={onClick}
      data-testid="what-can-i-grow-pill"
      className="hg-glass hg-glow hg-press group relative w-full rounded-2xl p-4 flex items-center gap-3 text-left"
      style={{ boxShadow: '0 0 26px -6px rgba(107,159,74,0.6), 0 10px 30px -14px rgba(26,67,49,0.4)' }}
    >
      <span className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(107,159,74,0.16)' }}>
        <Sun className="w-5 h-5" style={{ color: '#4E7A33' }} />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block font-bold text-[#1A4331]" style={{ fontFamily: 'Outfit, sans-serif' }}>What Can I Grow?</span>
        <span className="block text-sm text-[#5C665C]">Sow, transplant &amp; harvest this month</span>
      </span>
      <ArrowRight className="w-5 h-5 text-[#1A4331] group-hover:translate-x-1 transition-transform" />
    </button>
  );
}

export default EntryPill;
